import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "container-centered small-2"
  }, [_vm.stepContact == 1 ? _c("div", [_c("div", {
    staticClass: "contact-infos"
  }, [_c("h2", [_vm._v("Your request")]), _c("div", [_c(VTextField, {
    attrs: {
      label: "Subject",
      placeholder: "Subject of your request",
      autofocus: ""
    },
    model: {
      value: _vm.input.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "subject", $$v);
      },
      expression: "input.subject"
    }
  }), _vm.errorLabels.subject.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.subject) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextarea, {
    staticClass: "w100p",
    attrs: {
      name: "Your message",
      label: "Leave us a message here"
    },
    model: {
      value: _vm.input.message,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "message", $$v);
      },
      expression: "input.message"
    }
  }), _vm.errorLabels.message.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.message) + " ")]) : _vm._e()], 1)]), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.makeRequest();
      }
    }
  }, [_vm._v(" Send ")])], 1)]) : _vm._e(), _vm.stepContact == 2 ? _c("div", [_c("h2", [_vm._v("Thank you for your request !")]), _vm._v(" We will get in touch as soon as possible !"), _c("br"), _c("br"), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.home();
      }
    }
  }, [_vm._v(" Home ")])], 1) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };